const impersonate = useImpersonate()
const impersonateStore = useImpersonateStore()

export function menuHeader() {
  const goMenuUser = (menuUserClicked: string) => {
    const MENU_USER_TYPE: any = {
      gcCall: {
        event: 'usermenu_gc',
      },
      helpCenter: {
        event: 'usermenu_faq',
      },
      myCallings: {
        event: 'usermenu_support',
      },
      inPersonification: {
        event: 'usermenu_impersonate',
      },
      umPersonification: {
        event: 'usermenu_umpersonate',
      },
    }
    if (MENU_USER_TYPE[menuUserClicked].event === 'usermenu_impersonate') {
      impersonateStore.toggleImpersonateModal()
    }
    if (MENU_USER_TYPE[menuUserClicked].event === 'usermenu_umpersonate') {
      impersonate.removeImpersonate()
    }
  }

  return {
    goMenuUser,
  }
}
